<template>
    <div
        class="rounded-xl border border-gray-300 bg-gray-100 px-6 py-24 text-center"
    >
        <p class="text-md font-semibold text-gray-700">
            No Additional resources yet
        </p>
        <p class="mt-6 text-md text-gray-500">
            Use
            <span class="font-semibold text-gray-600">Add Resource</span>
            to attach flashcards, slides, a PDF, or an interactive image.
        </p>
    </div>
</template>
